"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bytes_write_dt = exports.bytes_replace_all = exports.bytes_select_count = exports.bezier2 = exports.bold_line = exports.draw_line = exports.bytes_to_hex = exports.hex_to_bytes = exports.bytes_write_int = exports.bytes_read_int = exports.concat_buf = exports.memcpy_buf = void 0;
function memcpy_buf(dst, offset, src, srcStart, len) {
    for (var i = 0; i < len; i++)
        dst[offset + i] = src[srcStart + i];
}
exports.memcpy_buf = memcpy_buf;
function concat_buf(arr) {
    var len = 0;
    for (var i = 0; i < arr.length; i++)
        len += arr[i].length;
    var npos = 0;
    var ret = new Uint8Array(len);
    for (var i = 0; i < arr.length; i++) {
        memcpy_buf(ret, npos, arr[i], 0, arr[i].length);
        npos += arr[i].length;
    }
    return ret;
}
exports.concat_buf = concat_buf;
function bytes_read_int(buf, pos, len, bBigEndian = false) {
    var ret = 0;
    if (bBigEndian) {
        for (var i = 0; i < len; i++) {
            ret += buf[pos + i] << (8 * (len - 1 - i));
        }
    }
    else {
        for (var i = 0; i < len; i++) {
            ret += buf[pos + i] << (8 * i);
        }
    }
    return ret;
}
exports.bytes_read_int = bytes_read_int;
function bytes_write_int(dst, pos, val, len_val, bBigEndian = false) {
    if (bBigEndian) {
        for (var i = 0; i < len_val; i++)
            dst[pos + i] = (val >> (8 * (len_val - 1 - i))) & 0xff;
    }
    else {
        for (var i = 0; i < len_val; i++)
            dst[pos + i] = (val >> (8 * i)) & 0xff;
    }
}
exports.bytes_write_int = bytes_write_int;
function hex_to_bytes(hex, len_byte) {
    var len = (hex.length + 1) / len_byte;
    var buf = new Uint8Array(len);
    for (var i = 0; i < len; ++i) {
        var pos = i * len_byte;
        buf[i] = parseInt(hex.slice(pos, pos + 2), 16);
    }
    return buf;
}
exports.hex_to_bytes = hex_to_bytes;
function bytes_to_hex(buf, interval) {
    var arr = Array.prototype.map.call(new Uint8Array(buf), function (bit) {
        return ("0" + bit.toString(16)).slice(-2);
    });
    return arr.join(interval);
}
exports.bytes_to_hex = bytes_to_hex;
function bytes_select(src, offset, dst) {
    var pos = offset;
    var pos_last = src.length - dst.length;
    while (pos <= pos_last) {
        var pos_s = pos;
        var pos_d = 0;
        var len_cmp = 0;
        while ((src[pos_s] == dst[pos_d]) && (len_cmp < dst.length)) {
            pos_s++;
            pos_d++;
            len_cmp++;
        }
        if (len_cmp == dst.length)
            return pos;
        pos++;
    }
    return -1;
}
function bytes_select_last(src, offset, dst) {
    var pos = src.length - dst.length;
    while (pos >= offset) {
        var pos_s = pos;
        var pos_d = 0;
        var len_cmp = 0;
        while ((src[pos_s] == dst[pos_d]) && (len_cmp < dst.length)) {
            pos_s++;
            pos_d++;
            len_cmp++;
        }
        if (len_cmp == dst.length)
            return pos;
        pos--;
    }
    return -1;
}
function bytes_select_count(pSrc, offset, pTarget) {
    var count = 0;
    var pos_start = offset;
    do {
        var pos = bytes_select(pSrc, pos_start, pTarget);
        if (pos < 0)
            break;
        pos_start += (pos + pTarget.length);
        count++;
    } while (1);
    return count;
}
exports.bytes_select_count = bytes_select_count;
function bytes_replace_last(pSrc, offset, pOld, pNew) {
    var pos = bytes_select_last(pSrc, offset, pOld);
    if (pos < 0)
        return pSrc.length;
    if (pOld.length == pNew.length) {
        memcpy_buf(pSrc, pos, pNew, 0, pNew.length);
        return pSrc.length;
    }
    var len_tmp = pSrc.length - pos - pOld.length;
    var pTmp = new Uint8Array(len_tmp);
    memcpy_buf(pTmp, 0, pSrc, pos + pOld.length, len_tmp);
    memcpy_buf(pSrc, pos, pNew, 0, pNew.length);
    memcpy_buf(pSrc, pos + pNew.length, pTmp, 0, pTmp.length);
    return pSrc.length + pNew.length - pOld.length;
}
function bytes_replace_all(pSrc, offset, pOld, pNew) {
    if (pOld.length < pNew.length) {
        return -1;
    }
    var count = bytes_select_count(pSrc, offset, pOld);
    if (0 == count)
        return pSrc.length;
    var len_src_new = pSrc.length;
    while (count > 0) {
        len_src_new = bytes_replace_last(pSrc, offset, pOld, pNew);
        count--;
    }
    return len_src_new;
}
exports.bytes_replace_all = bytes_replace_all;
function bytes_write_dt(pDest, offset, pSrc) {
    var y = 2000, m = 1, d = 1, h = 0, n = 0, s = 0;
    console.log(pSrc, y, m, d, h, n, s);
    pDest[offset + 0] = y & 0xff;
    pDest[offset + 1] = (y >> 8) & 0xff;
    pDest[offset + 2] = m;
    pDest[offset + 3] = d;
    pDest[offset + 4] = h;
    pDest[offset + 5] = n;
    pDest[offset + 6] = s;
    return true;
}
exports.bytes_write_dt = bytes_write_dt;
function draw_line(x0, y0, x1, y1) {
    if (x0 == x1 && y0 == y1) {
        return [x0, y0];
    }
    var step_x = 1;
    var step_y = 1;
    if (x0 > x1)
        step_x = -1;
    if (y0 > y1)
        step_y = -1;
    var data = [];
    if (x0 == x1) {
        for (var y = y0; y != y1; y += step_y)
            data.push([x0, y]);
    }
    else if (y0 == y1) {
        for (var x = x0; x != x1; x += step_x)
            data.push([x, y0]);
    }
    else {
        var des_x = Math.abs(x0 - x1);
        var des_y = Math.abs(y0 - y1);
        if (des_x == des_y) {
            for (var x = x0, y = y0; x != x1; x += step_x, y += step_y)
                data.push([x, y0]);
        }
        else if (des_x > des_y) {
            var e = des_y - des_x / 2;
            var y = y0;
            for (var x = x0; x != x1; x += step_x) {
                data.push([x, y]);
                if (e > 0) {
                    y += step_y;
                    e -= des_x;
                }
                e += des_y;
            }
        }
        else {
            var e = des_x - des_y / 2;
            var x = x0;
            for (var y = y0; y != y1; y += step_y) {
                data.push([x, y]);
                if (e > 0) {
                    x += step_x;
                    e -= des_y;
                }
                e += des_x;
            }
        }
    }
    data.push([x1, y1]);
    return data;
}
exports.draw_line = draw_line;
function bold_line(data, w, h, b) {
    if (b > 1) {
        var w = 64;
        var h = 64;
        var s = Math.floor((1 - b) / 2);
        var e = Math.floor(b / 2);
        var len = data.length;
        for (var i = 0; i < len; i++) {
            var xs = data[i][0];
            var ys = data[i][1];
            for (var x = s; x <= e; x++) {
                var x_c = xs + x;
                if (x_c < 0 || x_c >= w)
                    continue;
                for (var y = s; y <= e; y++) {
                    var y_c = ys + y;
                    if (y_c < 0 || y_c >= h)
                        continue;
                    data.push([x_c, y_c]);
                }
            }
        }
        data = Array.from(new Set(data));
    }
    return data;
}
exports.bold_line = bold_line;
function bezier2(x0, y0, x1, y1, x2, y2) {
    var dx01 = Math.abs(x1 - x0) + 1;
    var dy01 = Math.abs(y1 - y0) + 1;
    var dx12 = Math.abs(x2 - x1) + 1;
    var dy12 = Math.abs(y2 - y1) + 1;
    var count01 = Math.max(dx01, dy01);
    var count12 = Math.max(dx12, dy12);
    var count = Math.max(count01, count12);
    var data = [];
    for (var i = 0; i < count; i++) {
        var x01 = x0 * i / count + x1 * (1 - i) / count;
        var y01 = y0 * i / count + y1 * (1 - i) / count;
        var x12 = x1 * i / count + x2 * (1 - i) / count;
        var y12 = y1 * i / count + y2 * (1 - i) / count;
        var dx02 = Math.abs(x12 - x01) + 1;
        var dy02 = Math.abs(y12 - y01) + 1;
        var count02 = Math.max(dx02, dy02);
        for (var j = 0; j < count02; j++) {
            var x02 = x01 * j / count02 + x12 * (1 - j) / count02;
            var y02 = y01 * i / count02 + y12 * (1 - j) / count02;
            data.push([x02, y02]);
        }
    }
    return Array.from(new Set(data));
}
exports.bezier2 = bezier2;
